import React, { useEffect, useState } from "react";
import Popup from "../Popup/BasePopup";
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import Button from "../CommonFields/Button";
import { formatDate, formatTime } from "../../Utilities/helper";

const TimeSlotPopup = ({ timeslotsList, isOpen, onClose, title, mobileNo, onSubmitTimeSlot }) => {
  const dates = ['30/09/2024', '01/10/2024']
  const staticTimes = [
    { startTime: "08:00 AM", endTime: "10:00 AM" },
    { startTime: "09:00 AM", endTime: "10:00 AM" },
    { startTime: "09:00 AM", endTime: "10:00 AM" },
    { startTime: "08:00 AM", endTime: "10:00 AM" },
    { startTime: "09:00 AM", endTime: "10:00 AM" },
    { startTime: "09:00 AM", endTime: "10:00 AM" },

    // Add more time slots as needed
  ];
  const staticTimes2 = [
    { startTime: "08:00 AM", endTime: "10:00 AM" },
    { startTime: "09:00 AM", endTime: "10:00 AM" },

    // Add more time slots as needed
  ];
  const [activeTime, setActiveTime] = useState(0);
  const [activeDate, setActiveDate] = useState(0)
  const handlerSubmit = () => {
    var data = {
      callDate: timeslotsList[activeDate]?.date, callTime: `${timeslotsList[activeDate]?.data[activeTime]?.startTime} - ${timeslotsList[activeDate]?.data[activeTime]?.endTime}`
      , timeSlotId: timeslotsList[activeDate]?.data.find((item,index) => index.toString() === activeTime)
    }
    onSubmitTimeSlot(data)
  }
  const handlerChange = (e) => {
    setActiveTime(e.target.value)
  }
  
  return (
    <Popup isOpen={isOpen} onClose={onClose} title={title}>
      <div className="crm ">
        <div className="crm-dates my-4">
          {
            timeslotsList?.map((date, index) => {
              return (
                <div className={`f-14 ${activeDate == index ? "crm-active" : ""}`} onClick={() => {
                  setActiveTime(0)
                  setActiveDate(index)
                }}>
                  {formatDate(date?.date)}
                </div>
              )
            })
          }
        </div>
        <FormControl>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            value={activeTime}
            name="radio-buttons-group"
            onChange={handlerChange}
          >
            {timeslotsList[activeDate]?.data.map((data, index) => {
              return (<FormControlLabel value={index} control={<Radio />} label={(data?.startTime) + ' - ' + (data?.endTime)} />);
            })}
          </RadioGroup>
          {/* {
            activeDate == 0 ?
              <>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"

                  value={activeTime}
                  name="radio-buttons-group"
                  onChange={handlerChange}
                >
                  {
                    staticTimes?.map((time, index) => {
                      return (
                        <FormControlLabel value={index} control={<Radio />} label={time?.startTime + ' - ' + time?.endTime} />
                      )
                    })
                  }
                </RadioGroup>
              </>
              :
              <>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"

                  value={activeTime}
                  name="radio-buttons-group"
                  onChange={handlerChange}
                >
                  {
                    staticTimes2?.map((time, index) => {
                      return (
                        <FormControlLabel value={index} control={<Radio />} label={time?.startTime + ' - ' + time?.endTime} />
                      )
                    })
                  }
                </RadioGroup>
              </>
          } */}
        </FormControl>
        <div className="mt-4" >
          <p className="f-12 text-subscription text-center">
            you will receive a call on {JSON.parse(localStorage.getItem('profileLite'))?.phoneCode} {mobileNo}
          </p>
          <Button text={"submit"} onClick={handlerSubmit} />
        </div>
      </div>
    </Popup >
  );
};

export default TimeSlotPopup;
